import AppConfig from 'Constants/AppConfig';

export const homeRoutes = {
  countrySelector: { name: 'countrySelector', path: '/countrySelector' },
  home: { name: 'home', path: '/home' },
  login: { name: 'login', path: '/login' },
  signup: { name: 'signup', path: '/signup' }
}

export const homePageContent = [
  {
    heading: 'message.growYourBusiness',
    description: 'message.promoteYourBusiness',
    image: `${AppConfig.staticImagesBasePath}onboarding/home-img-1.png`
  },
  {
    heading: 'message.stayOnTop',
    description: 'message.knowYouCampaign',
    image: `${AppConfig.staticImagesBasePath}onboarding/home-img-3.png`
  },
  {
    heading: 'message.autoPilot',
    description: 'message.AIBased',
    image: `${AppConfig.staticImagesBasePath}onboarding/home-img-2.png`
  }
]
